export default __webpack_public_path__ + "static/media/blog-img-33.603e5d13.jpg";